module.exports = __webpack_public_path__ + "static/media/SuccessIcon.915bd449.svg";